import { render, staticRenderFns } from "./_add-fornecedor-picker.modal.vue?vue&type=template&id=90077a92&scoped=true"
import script from "./_add-fornecedor-picker.modal.vue?vue&type=script&lang=js"
export * from "./_add-fornecedor-picker.modal.vue?vue&type=script&lang=js"
import style0 from "./_add-fornecedor-picker.modal.vue?vue&type=style&index=0&id=90077a92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90077a92",
  null
  
)

export default component.exports